import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isEmpty from "lodash/isEmpty";
import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";

/* eslint-disable camelcase */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, BackButton, ColorBatch, Paper, Form, Input, Dropdown, CheckboxSwitch, Button, CreditData, CreditPaymentData, CreditPaymentsTable, SignPayment, showError, useUrlParams } from 'components';
import { creditsStatusName, creditStatusColorMap, CREDIT_PAYMENT_TYPE, paymentTypeOptions, PAYMENT_TYPE } from 'enums';
import { getCredit, getCreditPaymentPreview, postCreditPayment, getCreditEarlyRepaymentAmount, postCreditFullEarlyRepayment } from 'services';
import { positiveDoublePattern, showApiError, convertToAdditionalCurrency } from 'utils';
import { headerLeftTitle, headerLeftSubTitle, headerLeftId, list } from 'styles';
import { checkBoxStyle } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var CreditPayment = function CreditPayment(_ref) {
  var _location$state, _match$params, _queryParams$current$, _queryParams$current, _creditData$borrower, _creditData$borrower2, _creditData$borrower3, _creditPaymentData$fu2, _creditPaymentData$fu3, _creditPaymentData$fu4, _creditPaymentData$fu5, _creditPaymentData$fu6, _creditPaymentData$fu7, _creditPaymentData$fu8, _creditPaymentData$fu9, _creditPaymentData$fu10, _creditPaymentData$fu11, _creditPaymentData$fu12, _creditPaymentData$fu13, _creditPaymentData$fu14, _creditPaymentData$fu15, _creditPaymentData$fu16;

  var location = _ref.location,
      history = _ref.history,
      match = _ref.match;

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams;

  var queryParams = useRef(urlQueryParams);

  var _ref2 = (_location$state = location.state) !== null && _location$state !== void 0 ? _location$state : {},
      credit = _ref2.credit;

  var _ref3 = (_match$params = match.params) !== null && _match$params !== void 0 ? _match$params : {},
      creditId = _ref3.creditId;

  var _useState = useState(credit),
      _useState2 = _slicedToArray(_useState, 2),
      creditData = _useState2[0],
      setCreditData = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      creditPaymentData = _useState4[0],
      setCreditPaymentData = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      pdf = _useState6[0],
      setPdf = _useState6[1];

  var isFullEarlyPayment = (_queryParams$current$ = (_queryParams$current = queryParams.current) === null || _queryParams$current === void 0 ? void 0 : _queryParams$current.full_early_repayment) !== null && _queryParams$current$ !== void 0 ? _queryParams$current$ : false;
  var formData = {
    amount: creditData === null || creditData === void 0 ? void 0 : creditData.next_payment_amount,
    early_payment: false,
    payment_type: PAYMENT_TYPE.cash
  };
  useEffect(function () {
    fetchCreditData();
    isFullEarlyPayment && fetchCreditEarlyRepaymentAmount();
  }, []);

  var fetchCreditData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getCredit, _yield$getCredit2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getCredit(creditId);

            case 2:
              _yield$getCredit = _context.sent;
              _yield$getCredit2 = _slicedToArray(_yield$getCredit, 2);
              res = _yield$getCredit2[0];
              err = _yield$getCredit2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setCreditData(function (prev) {
                return _objectSpread(_objectSpread({}, prev), res);
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchCreditData() {
      return _ref4.apply(this, arguments);
    };
  }();

  var fetchCreditEarlyRepaymentAmount = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _yield$getCreditEarly, _yield$getCreditEarly2, res, err, isSeparatePayment;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getCreditEarlyRepaymentAmount(creditId);

            case 2:
              _yield$getCreditEarly = _context2.sent;
              _yield$getCreditEarly2 = _slicedToArray(_yield$getCreditEarly, 2);
              res = _yield$getCreditEarly2[0];
              err = _yield$getCreditEarly2[1];

              if (!err) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 8:
              isSeparatePayment = (creditData === null || creditData === void 0 ? void 0 : creditData.credit_payment_type) === CREDIT_PAYMENT_TYPE.home_visit_fee_separate_payment;

              if (!(isSeparatePayment && !(res !== null && res !== void 0 && res.signed_documents_for_full_early_repayment))) {
                _context2.next = 12;
                break;
              }

              showError('Трябва да бъде подписано искане за предсрочно погасяване от служител на кредитора/кредитния посредник');
              return _context2.abrupt("return", history.push({
                pathname: "/credits/details/".concat(creditId),
                state: {
                  credit: creditData
                }
              }));

            case 12:
              handleCalculate({
                values: {
                  amount: res === null || res === void 0 ? void 0 : res.amount
                }
              }, res);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchCreditEarlyRepaymentAmount() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleCalculate = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref6, fullEarlyPaymentData) {
      var values, _yield$getCreditPayme, _yield$getCreditPayme2, res, err;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              values = _ref6.values;

              if (!(Number(values === null || values === void 0 ? void 0 : values.amount) > Number(creditData === null || creditData === void 0 ? void 0 : creditData.total_amount_to_be_payed))) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return", showError('Въведента сума за вноската надвишава стойността на кредита!'));

            case 3:
              _context3.next = 5;
              return getCreditPaymentPreview(creditId, _objectSpread(_objectSpread({}, values), {}, {
                full_early_repayment: isFullEarlyPayment
              }));

            case 5:
              _yield$getCreditPayme = _context3.sent;
              _yield$getCreditPayme2 = _slicedToArray(_yield$getCreditPayme, 2);
              res = _yield$getCreditPayme2[0];
              err = _yield$getCreditPayme2[1];

              if (!err) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 11:
              setCreditPaymentData(_objectSpread(_objectSpread({}, res), fullEarlyPaymentData && {
                full_early_repayment_data: fullEarlyPaymentData
              }));
              return _context3.abrupt("return", true);

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleCalculate(_x, _x2) {
      return _ref7.apply(this, arguments);
    };
  }();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(values) {
      var _creditPaymentData$fu;

      var _ref9, _ref10, res, err, url;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!isFullEarlyPayment) {
                _context4.next = 6;
                break;
              }

              _context4.next = 3;
              return postCreditFullEarlyRepayment(creditId, _objectSpread(_objectSpread({}, values), {}, {
                amount: creditPaymentData === null || creditPaymentData === void 0 ? void 0 : (_creditPaymentData$fu = creditPaymentData.full_early_repayment_data) === null || _creditPaymentData$fu === void 0 ? void 0 : _creditPaymentData$fu.amount
              }));

            case 3:
              _context4.t0 = _context4.sent;
              _context4.next = 9;
              break;

            case 6:
              _context4.next = 8;
              return postCreditPayment(creditId, _objectSpread(_objectSpread({}, values), {}, {
                amount: values === null || values === void 0 ? void 0 : values.amount
              }));

            case 8:
              _context4.t0 = _context4.sent;

            case 9:
              _ref9 = _context4.t0;
              _ref10 = _slicedToArray(_ref9, 2);
              res = _ref10[0];
              err = _ref10[1];

              if (!err) {
                _context4.next = 15;
                break;
              }

              return _context4.abrupt("return", showApiError(err));

            case 15:
              url = URL.createObjectURL(new File([res], 'filename.json', {
                type: 'application/pdf'
              }));
              setPdf({
                url: url,
                isSign: false
              });

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleSubmit(_x3) {
      return _ref8.apply(this, arguments);
    };
  }();

  var handleBack = function handleBack() {
    fetchCreditData();
    setCreditPaymentData();
    setPdf();
  };

  var handleDelete = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(data) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setCreditData(function (prev) {
                var _prev$payments;

                return _objectSpread(_objectSpread({}, prev), {}, {
                  payments: prev === null || prev === void 0 ? void 0 : (_prev$payments = prev.payments) === null || _prev$payments === void 0 ? void 0 : _prev$payments.map(function (el) {
                    return (el === null || el === void 0 ? void 0 : el.id) === (data === null || data === void 0 ? void 0 : data.id) ? data : el;
                  })
                });
              });

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleDelete(_x4) {
      return _ref11.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white",
    padding: "2em",
    className: "container-xxl"
  }, ___EmotionJSX(Col, {
    sm: "auto",
    position: "relative",
    margin: "0 0 1.4em"
  }, ___EmotionJSX(BackButton, null), ___EmotionJSX("h6", {
    css: headerLeftTitle
  }, "\u041D\u043E\u043C\u0435\u0440: ", creditData === null || creditData === void 0 ? void 0 : creditData.number), ___EmotionJSX("h6", {
    css: headerLeftSubTitle
  }, "\u0421\u0443\u043C\u0430: ", creditData === null || creditData === void 0 ? void 0 : creditData.amount, " ", creditData === null || creditData === void 0 ? void 0 : creditData.currency, " /", convertToAdditionalCurrency({
    value: creditData === null || creditData === void 0 ? void 0 : creditData.amount,
    fromCurrency: creditData === null || creditData === void 0 ? void 0 : creditData.currency
  })), ___EmotionJSX("div", {
    css: headerLeftId
  }, ___EmotionJSX("span", null, creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower = creditData.borrower) === null || _creditData$borrower === void 0 ? void 0 : _creditData$borrower.first_name, " ", creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower2 = creditData.borrower) === null || _creditData$borrower2 === void 0 ? void 0 : _creditData$borrower2.middle_name, " ", creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower3 = creditData.borrower) === null || _creditData$borrower3 === void 0 ? void 0 : _creditData$borrower3.last_name), ___EmotionJSX(ColorBatch, {
    type: creditStatusColorMap[creditData === null || creditData === void 0 ? void 0 : creditData.status],
    fontSize: "1rem",
    margin: "0 0 0 6px"
  }, creditsStatusName[creditData === null || creditData === void 0 ? void 0 : creditData.status])))), pdf ? ___EmotionJSX(Row, {
    backgroundColor: "white",
    padding: "0 2em",
    className: "container-xxl"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(SignPayment, {
    document: pdf,
    onBack: handleBack,
    onSignSuccess: function onSignSuccess(data) {
      return setPdf(data);
    },
    creditId: creditId
  }))) : ___EmotionJSX(Row, {
    backgroundColor: "white",
    padding: "0 2em",
    className: "container-xxl"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref12) {
      var css = _ref12.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0412\u044A\u0432\u0435\u0434\u0438 \u0432\u043D\u043E\u0441\u043A\u0430 \u043F\u043E \u043A\u0440\u0435\u0434\u0438\u0442\u0430"));
    },
    margin: "0 0 2em 0"
  }, ___EmotionJSX(CreditData, {
    credit: creditData
  }), !_isEmpty(creditData === null || creditData === void 0 ? void 0 : creditData.payments) && ___EmotionJSX(CreditPaymentsTable, {
    creditId: Number(creditId),
    payments: creditData === null || creditData === void 0 ? void 0 : creditData.payments,
    creditPaymentType: creditData === null || creditData === void 0 ? void 0 : creditData.credit_payment_type,
    onDelete: handleDelete,
    onSign: function onSign(data) {
      return setPdf({
        url: data === null || data === void 0 ? void 0 : data.url,
        paymentId: data === null || data === void 0 ? void 0 : data.paymentId,
        documentId: data === null || data === void 0 ? void 0 : data.documentId,
        isSign: false
      });
    }
  }), ___EmotionJSX(Form, {
    onSubmit: handleCalculate,
    values: formData
  }, ___EmotionJSX(Row, {
    horizontalGap: 8,
    align: "center"
  }, !isFullEarlyPayment && ___EmotionJSX(Col, {
    sm: 12,
    css: checkBoxStyle
  }, ___EmotionJSX(CheckboxSwitch, {
    fluid: true,
    label: "\u041F\u0440\u0435\u0434\u043F\u043B\u0430\u0449\u0430\u043D\u0435",
    formId: "early_payment"
  })), !isFullEarlyPayment && ___EmotionJSX(Col, {
    sm: true
  }, function (_ref13) {
    var mergedValues = _ref13.mergedValues;
    return ___EmotionJSX(Input, {
      pattern: positiveDoublePattern,
      number: true,
      formId: "amount",
      label: "\u0412\u043D\u043E\u0441\u043A\u0430 \u0432 ".concat(creditData === null || creditData === void 0 ? void 0 : creditData.currency),
      helpText: "| \u041E\u0431\u0449\u0430 \u0441\u0443\u043C\u0430: ".concat(mergedValues !== null && mergedValues !== void 0 && mergedValues.early_payment ? creditData === null || creditData === void 0 ? void 0 : creditData.total_amount_to_be_payed : creditData === null || creditData === void 0 ? void 0 : creditData.total_amount_without_future_interests, " ").concat(creditData === null || creditData === void 0 ? void 0 : creditData.currency),
      required: true
    });
  }), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Dropdown, {
    noClear: true,
    required: true,
    formId: "payment_type",
    label: "\u041D\u0430\u0447\u0438\u043D \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435",
    options: paymentTypeOptions,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), !isFullEarlyPayment && ___EmotionJSX(Col, {
    sm: "auto"
  }, function (_ref14) {
    var onSubmit = _ref14.onSubmit;
    return ___EmotionJSX(Button, {
      type: "info",
      onClick: onSubmit,
      className: "mb07"
    }, "\u0418\u0437\u0447\u0438\u0441\u043B\u0438");
  })), isFullEarlyPayment && ___EmotionJSX("div", {
    css: list
  }, ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041E\u0431\u0449\u0430 \u0441\u0443\u043C\u0430 \u0441 \u0442\u0430\u043A\u0441\u0438"), ___EmotionJSX("div", {
    className: "multi-price-wrap"
  }, ___EmotionJSX("p", {
    "data-value": "earlyRepaymentAmount.amount_with_fees",
    className: "value"
  }, "".concat((_creditPaymentData$fu2 = creditPaymentData === null || creditPaymentData === void 0 ? void 0 : (_creditPaymentData$fu3 = creditPaymentData.full_early_repayment_data) === null || _creditPaymentData$fu3 === void 0 ? void 0 : _creditPaymentData$fu3.amount_with_fees) !== null && _creditPaymentData$fu2 !== void 0 ? _creditPaymentData$fu2 : '--', " ").concat(creditPaymentData === null || creditPaymentData === void 0 ? void 0 : (_creditPaymentData$fu4 = creditPaymentData.full_early_repayment_data) === null || _creditPaymentData$fu4 === void 0 ? void 0 : _creditPaymentData$fu4.currency)), ___EmotionJSX("p", {
    className: "value"
  }, convertToAdditionalCurrency({
    value: creditPaymentData === null || creditPaymentData === void 0 ? void 0 : (_creditPaymentData$fu5 = creditPaymentData.full_early_repayment_data) === null || _creditPaymentData$fu5 === void 0 ? void 0 : _creditPaymentData$fu5.amount_with_fees,
    fromCurrency: creditPaymentData === null || creditPaymentData === void 0 ? void 0 : (_creditPaymentData$fu6 = creditPaymentData.full_early_repayment_data) === null || _creditPaymentData$fu6 === void 0 ? void 0 : _creditPaymentData$fu6.currency
  })))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0430\u0442\u0438 \u0442\u0430\u043A\u0441\u0438"), ___EmotionJSX("div", {
    className: "multi-price-wrap"
  }, ___EmotionJSX("p", {
    "data-value": "earlyRepaymentAmount.amount_with_fees",
    className: "value"
  }, "".concat((_creditPaymentData$fu7 = creditPaymentData === null || creditPaymentData === void 0 ? void 0 : (_creditPaymentData$fu8 = creditPaymentData.full_early_repayment_data) === null || _creditPaymentData$fu8 === void 0 ? void 0 : _creditPaymentData$fu8.removed_fees_amount) !== null && _creditPaymentData$fu7 !== void 0 ? _creditPaymentData$fu7 : '--', " ").concat(creditPaymentData === null || creditPaymentData === void 0 ? void 0 : (_creditPaymentData$fu9 = creditPaymentData.full_early_repayment_data) === null || _creditPaymentData$fu9 === void 0 ? void 0 : _creditPaymentData$fu9.currency)), ___EmotionJSX("p", {
    className: "value"
  }, convertToAdditionalCurrency({
    value: creditPaymentData === null || creditPaymentData === void 0 ? void 0 : (_creditPaymentData$fu10 = creditPaymentData.full_early_repayment_data) === null || _creditPaymentData$fu10 === void 0 ? void 0 : _creditPaymentData$fu10.removed_fees_amount,
    fromCurrency: creditPaymentData === null || creditPaymentData === void 0 ? void 0 : (_creditPaymentData$fu11 = creditPaymentData.full_early_repayment_data) === null || _creditPaymentData$fu11 === void 0 ? void 0 : _creditPaymentData$fu11.currency
  })))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041E\u0431\u0449\u043E \u0437\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435"), ___EmotionJSX("div", {
    className: "multi-price-wrap"
  }, ___EmotionJSX("p", {
    "data-value": "earlyRepaymentAmount.amount_with_fees",
    className: "value"
  }, "".concat((_creditPaymentData$fu12 = creditPaymentData === null || creditPaymentData === void 0 ? void 0 : (_creditPaymentData$fu13 = creditPaymentData.full_early_repayment_data) === null || _creditPaymentData$fu13 === void 0 ? void 0 : _creditPaymentData$fu13.amount) !== null && _creditPaymentData$fu12 !== void 0 ? _creditPaymentData$fu12 : '--', " ").concat(creditPaymentData === null || creditPaymentData === void 0 ? void 0 : (_creditPaymentData$fu14 = creditPaymentData.full_early_repayment_data) === null || _creditPaymentData$fu14 === void 0 ? void 0 : _creditPaymentData$fu14.currency)), ___EmotionJSX("p", {
    className: "value"
  }, convertToAdditionalCurrency({
    value: creditPaymentData === null || creditPaymentData === void 0 ? void 0 : (_creditPaymentData$fu15 = creditPaymentData.full_early_repayment_data) === null || _creditPaymentData$fu15 === void 0 ? void 0 : _creditPaymentData$fu15.amount,
    fromCurrency: creditPaymentData === null || creditPaymentData === void 0 ? void 0 : (_creditPaymentData$fu16 = creditPaymentData.full_early_repayment_data) === null || _creditPaymentData$fu16 === void 0 ? void 0 : _creditPaymentData$fu16.currency
  }))))), ___EmotionJSX(CreditPaymentData, {
    credit: creditPaymentData
  }), ___EmotionJSX(Row, {
    horizontalGap: 16,
    verticalGap: 8
  }, ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-end"
  }, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: function onClick() {
      return history.push('/credits');
    },
    margin: "0 1em 0 0"
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"), function (_ref15) {
    var mergedValues = _ref15.mergedValues;
    return ___EmotionJSX(Button, {
      onClick: function onClick() {
        return handleSubmit(mergedValues);
      }
    }, "\u0412\u044A\u0432\u0435\u0434\u0438");
  })))))));
};

CreditPayment.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object
};
export default CreditPayment;